export const taxMessageSelector = (state) => state.taxMessageDetailReducer;
